import React, { useState } from "react";
import { useSelector } from "react-redux";
import firebase from "firebase/app";
import "firebase/storage";
import {
  Button,
  Dimmer,
  Divider,
  Label,
  List,
  Loader,
  Message,
  Form,
  Grid,
  Header,
  Segment,
} from "semantic-ui-react";

// import pdfListEnum from "./autoFillEnum.json";
// import resultJSON from "./result_v1.json";
import initialState from "./pdfStateObject.json";
import pdfRefObject from "./pdfReferenceObject.json";
import exceptionArray from "./exceptionValueList.json";

const personType = ["interpreter", "preparer", "primary", "secondary"];
const keyIdArray = [
  "mailStateDropDown",
  "physicalStateDropDown",
  "maleCheckbox",
  "femaleCheckbox",
  "mailProvince",
  "physicalProvince",
  "mailZipCode",
  "physicalZipCode",
  "mailPostalCode",
  "physicalPostalCode",
  "uscisElisNo",
];

const PdfForm = ({ type, formName }) => {
  const uid = useSelector((state) => state.firebase.auth.uid);
  const [active, setActive] = useState(false);
  const [loader, setLoader] = useState(false);
  const [nameArray, setNameArray] = useState([]);
  const [obj, setObj] = useState(initialState);

  // Convert to Module as util tools
  // const handleUpdate = async () => {
  //   const pdfListObj = require("./pdfList.json");

  //   for (let i = 0; i < Object.keys(pdfListObj.dataObject).length; i++) {
  //     firebase
  //       .firestore()
  //       .collection("autoFill")
  //       .doc(Object.keys(pdfListObj.dataObject)[i])
  //       .set(pdfListObj.dataObject[Object.keys(pdfListObj.dataObject)[i]], {
  //         merge: true,
  //       })
  //       .catch((err) => {
  //         global.alert(err);
  //       });
  //   }

  //   global.alert("Successfull please check!");
  // };

  // Convert to Module as util tools
  // const handleRead = async () => {
  //   const { PDFDocument } = require("pdf-lib");

  //   // const fileName = "n-400";
  //   const formPdfBytes = await global
  //     .fetch(
  //       `https://storage.googleapis.com/auto-fill/forms/i-601a%20Guido%20Hernandez-6-9.pdf`
  //     )
  //     .then((res) => res.arrayBuffer());

  //   const pdfArray = [];

  //   const pdfDoc = await PDFDocument.load(formPdfBytes);

  //   const form = await pdfDoc.getForm();

  //   const fields = await form.getFields();
  //   await fields.forEach((field) => {
  //     const type = field.constructor.name;
  //     const name = field.getName();
  //     if (type === "PDFTextField") {
  //       const val = form.getTextField(name);
  //       const text = val.getText();
  //       if (text) {
  //         pdfArray.push(
  //           {
  //             key: "",
  //             value: text !== "" && text,
  //             fieldId: name,
  //             type: "Text",
  //           }
  //         );
  //       }
  //     }
  //   });

  //   await global.alert("Complete");
  //   console.log(pdfArray);
  // };

  const handleAutoFill = async () => {
    // console.log(obj[personType[2]]["uscisElisNo"]);

    const { PDFDocument } = require("pdf-lib");
    // const alertify = require("alertifyjs");
    const crypto = require("crypto");
    const formArray = await initialState[formName].files;
    const currentTime = await new Date();

    setActive(true);
    let i = await 0;

    while (i < formArray.length) {
      const formPdfBytes = await global
        .fetch(`${formArray[i].url}`)
        .then((res) => res.arrayBuffer());

      setLoader(false);

      const pdfDoc = await PDFDocument.load(formPdfBytes);

      const form = await pdfDoc.getForm();

      for (let j = 0; j < personType.length; j++) {
        if (pdfRefObject[formArray[i].pdf][personType[j]].length !== 0) {
          for (
            let k = 0;
            k < pdfRefObject[formArray[i].pdf][personType[j]].length;
            k++
          ) {
            if (
              keyIdArray.indexOf(
                pdfRefObject[formArray[i].pdf][personType[j]][k].key
              ) === -1 &&
              exceptionArray.indexOf(
                pdfRefObject[formArray[i].pdf][personType[j]][k].fieldId
              ) === -1
            ) {
              if (
                obj[personType[j]] &&
                pdfRefObject[formArray[i].pdf][personType[j]][k].key
              ) {
                const pdfID = await pdfRefObject[formArray[i].pdf][
                  personType[j]
                ][k].fieldId;

                const stateID = await obj[personType[j]][
                  pdfRefObject[formArray[i].pdf][personType[j]][k].key
                ];

                await form.getTextField(pdfID).setText(stateID);
              }
            }
          }
        }
      }

      const pdfBytes = await pdfDoc.save();

      const nameId = await crypto.randomBytes(16).toString("hex");

      const fileName = `${+currentTime}_${formArray[i].pdf}_${nameId}`;

      const storageRef = await firebase
        .storage()
        .ref(`autoFill/${uid}/${fileName}.pdf`);

      await storageRef
        .put(pdfBytes, {
          contentType: "application/pdf",
        })
        // eslint-disable-next-line no-loop-func
        .catch((err) => {
          global.alert(err);
        });

      // eslint-disable-next-line no-loop-func
      await storageRef.getDownloadURL().then((url) => {
        // firebase.firestore().collection("documentList");
        const tempArray = nameArray;
        tempArray[i] = {
          fileName: fileName,
          fileUrl: url,
        };
        setNameArray([...tempArray]);
      });

      await i++;
    }

    const groupId = await crypto.randomBytes(16).toString("hex");

    const groupName = `${+currentTime}_${formName}_${groupId}`;

    await firebase
      .firestore()
      .collection("documentList")
      .doc(uid)
      .collection("owner")
      .doc(groupName)
      .set({
        groupName: groupName,
        documentList: nameArray,
      })
      .then(() => {
        setNameArray([]);
        setLoader(true);
      })
      .catch((err) => {
        global.alert(err);
      });
  };

  return (
    <>
      <Dimmer active={active}>
        {loader === false ? (
          <>
            <Loader size="big" inline indeterminate>
              Preparing Files
            </Loader>
            <Divider />
          </>
        ) : (
          <>
            <Button
              size="big"
              color="google plus"
              onClick={() => setActive(false)}
            >
              Back to List
            </Button>
            <Divider />
          </>
        )}
        <div>
          {nameArray !== [] &&
            nameArray.map((item) => (
              <Segment key={item.fileName} size="large">
                <List relaxed="very">
                  <List.Item>
                    <List.Icon
                      color="red"
                      name="file pdf outline"
                      size="large"
                      verticalAlign="middle"
                    />
                    <List.Content verticalAlign="middle">
                      <List.Description>
                        {item.fileName.split("_")[1]}
                        <b> processed!</b>
                      </List.Description>
                    </List.Content>
                    <List.Icon
                      style={{ marginRight: "100px" }}
                      color="green"
                      name="check circle outline"
                      size="large"
                      verticalAlign="middle"
                    />
                  </List.Item>
                </List>
              </Segment>
            ))}
        </div>
      </Dimmer>
      <Segment style={{ overflow: "auto", maxHeight: "57vh" }}>
        <Form>
          <Grid columns={3} divided>
            <Grid.Row textAlign="center">
              <Grid.Column></Grid.Column>
              <Grid.Column>
                <>
                  {obj[formName].fields[type] === null ? (
                    <Message color="yellow">
                      There is no data for auto-filling
                    </Message>
                  ) : (
                    <Button
                      color="instagram"
                      fluid
                      onClick={() => handleAutoFill()}
                    >
                      RUN
                    </Button>
                  )}
                </>
                <Divider />
              </Grid.Column>
              <Grid.Column></Grid.Column>
              <Grid.Column>
                {obj[formName].fields[type] !== null && (
                  <Header>Biographic Information</Header>
                )}
                <p>
                  {obj[formName].fields[type] &&
                    Object.keys(obj[formName].fields[type]).map(
                      (item) =>
                        item.slice(0, 4) !== "phys" &&
                        item.slice(0, 4) !== "mail" && (
                          <Segment>
                            <Grid stackable columns={2}>
                              <Grid.Column textAlign="left" width={6}>
                                <Form.Field>
                                  {obj[type] && obj[type][item] !== "" ? (
                                    <Label color="teal" pointing="below">
                                      {obj[type][item]}
                                    </Label>
                                  ) : (
                                    <Label color="red">No Data</Label>
                                  )}
                                  <Form.Field type="text">{item}</Form.Field>
                                </Form.Field>
                              </Grid.Column>
                              <Grid.Column width={10}>
                                <Form.Field>
                                  <Form.Input
                                    fluid
                                    placeholder={item}
                                    onChange={(e) =>
                                      setObj({
                                        ...obj,
                                        [type]: {
                                          ...obj[type],
                                          [item]:
                                            e && e.target && e.target.value,
                                        },
                                      })
                                    }
                                  />
                                </Form.Field>
                              </Grid.Column>
                            </Grid>
                          </Segment>
                        )
                    )}
                </p>
              </Grid.Column>
              <Grid.Column>
                {obj[formName].fields[type] !== null && (
                  <Header>Mailing Address Information</Header>
                )}
                {obj[formName].fields[type] &&
                  Object.keys(obj[formName].fields[type]).map(
                    (item) =>
                      item.slice(0, 4) === "mail" && (
                        <Segment>
                          <Grid stackable columns={2}>
                            <Grid.Column textAlign="left" width={6}>
                              <Form.Field>
                                {obj[type] && obj[type][item] !== "" ? (
                                  <Label color="teal" pointing="below">
                                    {obj[type][item]}
                                  </Label>
                                ) : (
                                  <Label color="red">No Data</Label>
                                )}
                                <Form.Field type="text">{item}</Form.Field>
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={10}>
                              <Form.Field>
                                <Form.Input
                                  fluid
                                  placeholder={item}
                                  onChange={(e) =>
                                    setObj({
                                      ...obj,
                                      [type]: {
                                        ...obj[type],
                                        [item]: e && e.target && e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Field>
                            </Grid.Column>
                          </Grid>
                        </Segment>
                      )
                  )}
              </Grid.Column>
              <Grid.Column>
                {obj[formName].fields[type] !== null && (
                  <Header>Physical Address Information</Header>
                )}
                {obj[formName].fields[type] &&
                  Object.keys(obj[formName].fields[type]).map(
                    (item) =>
                      item.slice(0, 4) === "phys" && (
                        <Segment>
                          <Grid stackable columns={2}>
                            <Grid.Column textAlign="left" width={6}>
                              <Form.Field>
                                {obj[type] && obj[type][item] !== "" ? (
                                  <Label color="teal" pointing="below">
                                    {obj[type][item]}
                                  </Label>
                                ) : (
                                  <Label color="red">No Data</Label>
                                )}
                                <Form.Field type="text">{item}</Form.Field>
                              </Form.Field>
                            </Grid.Column>
                            <Grid.Column width={10}>
                              <Form.Field>
                                <Form.Input
                                  fluid
                                  placeholder={item}
                                  onChange={(e) =>
                                    setObj({
                                      ...obj,
                                      [type]: {
                                        ...obj[type],
                                        [item]: e && e.target && e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Field>
                            </Grid.Column>
                          </Grid>
                        </Segment>
                      )
                  )}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row
              style={{ overflow: "auto", minHeight: "55vh" }}
            ></Grid.Row>
          </Grid>
        </Form>
      </Segment>
    </>
  );
};

export default PdfForm;

// for (let i = 0; i < personType.length; i++) {
//   await value[personType[i]].map((item) => {
//     if (item !== []) {
//       for (let j = 0; j < value[personType[i]].length; j++) {
//         if (
//           value[personType[i]][j].key !== "" &&
//           value[personType[i]][j].key !== "personType" &&
//           value[personType[i]][j].key !== "mailStateDropDown" &&
//           value[personType[i]][j].key !== "physicalStateDropDown"
//         ) {
//           // if (value[personType[i]][j].key.slice(0, 4) === "mail") {
//           //   formObj[personType[i]][item.value] &&
//           //     form
//           //       .getTextField(formObj[personType[i]][item.value])
//           //       .setText(formObj[personType[i]].mailingAdd[item.key]);
//           // } else if (
//           //   value[personType[i]][j].key.slice(0, 4) === "phys"
//           // ) {
//           //   formObj[personType[i]][item.value] &&
//           //     form
//           //       .getTextField(formObj[personType[i]][item.value])
//           //       .setText(
//           //         formObj[personType[i]].physicalAdd[item.key]
//           //       );
//           // } else {
//           //   formObj[personType[i]][item.value] &&
//           //     form
//           //       .getTextField(formObj[personType[i]][item.value])
//           //       .setText(formObj[personType[i]].bio[item.key]);
//           // }
//           // global.alert(JSON.stringify(formObj[personType[i]].bio));
//           // form
//           //   .getTextField(formObj[personType[i]][item.value])
//           //   .setText(formObj[personType[i]].bio[item.key]);
//           // form
//           //   .getTextField(value[personType[i]][j].value)
//           //   .setText(formObj[personType[i]].bio[item.key]);
//           // global.alert(value[personType[i]][j].key) //aNumber etc...
//           // global.alert(value[personType[i]][j].value) //TextField1_AIl_pre etc...
//           // global.alert(formObj[personType[i]].bio[value[personType[i]][j].key]) //Value
//           // global.alert(JSON.stringify(value[personType[i]][j].value));
//           // global.alert(value[personType[i]][j].value)
//           // global.alert(JSON.stringify(formObj[personType[i]].bio))
//         }
//       }
//     }
//   });
// }

// global.alert(Object.keys(formObj[personType[i]][infoType[k]])[q])
// global.alert(
//   JSON.stringify(
//     formObj[personType[i]][infoType[k]][
//       Object.keys(formObj[personType[i]][infoType[k]])[q]
//     ]
//   )
// );

// for (let i = 0; i < Object.keys(formObj).length; i++) {
//   for (let j = 0; j < 3; j++) {
//     // formObj -> personType -> bio
//     for (
//       let k = 0;
//       k < Object.keys(formObj[personType[i]][infoType[j]]).length;
//       k++
//     ) {
//       global.alert(formObj[personType[i]][infoType[j]][k].key);
//     }
//   }
// }

// form.getTextField(item.value).setText(formObj[personType[i]][item.value]);
// if (item.value.slice(0, 4) === "mail") {
//   return form
//     .getTextField(formObj[personType[i]][item.value])
//     .setText(formObj[personType[i]].mailingAdd[item.key]);
// } else if (item.value.slice(0, 4) === "phys") {
//   return form
//     .getTextField(formObj[personType[i]][item.value])
//     .setText(formObj[personType[i]].physicalAdd[item.key]);
// } else {
//   return form
//     .getTextField(formObj[personType[i]][item.value])
//     .setText(formObj[personType[i]].bio[item.key]);
// }

// if (tempObj.interpreter[value]) {
//   if (
//     key !== "personType" ||
//     key !== "mailStateDropDown" ||
//     key !== "physicalStateDropDown"
//   ) {
//     // await form
//     //   .getTextField(tempObj.interpreter[value])
//     //   .setText(formObj);
//     await global.alert(key.slice(0,3))
//   }
// }

// for (const [key, value] of Object.entries(formObj)) {
//   if (formName.pre[key]) {
//     if (key !== "stateName") {
//       await form.getTextField(formName.pre[key]).setText(value);
//     }
//   }
// }
// await form.getTextField("Pt1Line1_USCISOnlineAcctNumber").setText("test");
// await global.alert(JSON.stringify(form));

// if (pdfListEnum[formName][type] !== null) {
//   for (let i = 0; i < Object.keys(pdfListEnum[formName][type]).length; i++) {
//     tempArr.push(pdfListEnum[formName][type][i].key);
//   }
// }
// const uniq = [...new Set(tempArr)];

// global.alert(value[personType[i]][j].key);
// if()
// form
//   .getTextField(value[personType[i]][j].value)
//   .setText(formObj[personType[i]].bio[value[personType[i]][j].key]);
// global.alert(
//   formObj[personType[i]].bio[value[personType[i]][j].key]
// );

// useEffect(() => {
//   firebase
//     .firestore()
//     .collection("formFields")
//     .doc(formName)
//     .get()
//     .then((doc) => {
//       setFormObj(doc.data());
//     })
//     .catch((err) => {
//       global.alert(err);
//     });

//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);

// global.alert(JSON.stringify(formArray[i].pdf));

// for (let i = 0; formArray[i].length; i++) {
//   // eslint-disable-next-line no-loop-func
//   await resultJSON[formArray[i].pdf].primary.forEach((item) => {
//     form
//       .getTextField(item.value)
//       .setText("T");
//   });
// }

// for (let i = 0; i < personType.length; i++) {
//   if (resultJSON[formArray[i].pdf][personType[i]].length !== 0) {
//     for (
//       let j = 0;
//       j < resultJSON[formArray[i].pdf][personType[i]].length;
//       j++
//     ) {
//       for (let q = 0; q < infoType.length; q++) {
//         for (
//           let k = 0;
//           k < formObj[personType[i]][infoType[q]].length;
//           k++
//         ) {
//           if (formObj[personType[i]][infoType[q]][k]) {
//             global.alert(
//               JSON.stringify(formObj[personType[i]][infoType[q]][k])
//             );
//           }
//         }
//       }

//       // if (formObj[personType[i]][infoType[j]]) {
//       //   global.alert(JSON.stringify(formObj[personType[i]][infoType[j]]));
//       // }

//       // form
//       // .getTextField(resultJSON[formArray[i].pdf][personType[i]][j].value)
//       // .setText(
//       //   formObj[personType[i]][infoType[k]][
//       //     Object.keys(formObj[personType[i]][infoType[k]])[q]
//       //   ]
//       // );
//       // global.alert(resultJSON[formArray[i].pdf][personType[i]][j].value);
//     }
//   }
// }

// for (const [key, value] of Object.entries(tempObj)) {
//   if (tempObj[key]) {
//     for (let i = 0; i < personType.length; i++) {
//       for (
//         let j = 0;
//         j < Object.keys(tempObj[key][personType[i]]).length;
//         j++
//       ) {
//         for (let k = 0; k < infoType.length; k++) {
//           for (
//             let q = 0;
//             q < Object.keys(formObj[personType[i]][infoType[k]]).length;
//             q++
//           ) {
//             if (
//               tempObj[key][personType[i]][j].key !== "" &&
//               tempObj[key][personType[i]][j].key !== "mName" &&
//               tempObj[key][personType[i]][j].key !== "Address2" &&
//               tempObj[key][personType[i]][j].key !== "personType" &&
//               tempObj[key][personType[i]][j].key !==
//                 "mailStateDropDown" &&
//               tempObj[key][personType[i]][j].key !==
//                 "physicalStateDropDown" &&
//               tempObj[key][personType[i]][j].key !==
//                 "aptSteFlrCheckBox" &&
//               tempObj[key][personType[i]][j].key !== "genderCheckbox"
//             ) {
//               if (
//                 // eslint-disable-next-line eqeqeq
//                 tempObj[key][personType[i]][j].key ==
//                 Object.keys(formObj[personType[i]][infoType[k]])[q]
//               ) {
//                 await resultJSON[formArray[i].pdf][personType[i]].forEach(
//                   (item) => {
//                     if (
//                       item.value === tempObj[key][personType[i]][j].value
//                     ) {
//                       form
//                         .getTextField(
//                           tempObj[key][personType[i]][j].value
//                         )
//                         .setText(
//                           formObj[personType[i]][infoType[k]][
//                             Object.keys(
//                               formObj[personType[i]][infoType[k]]
//                             )[q]
//                           ]
//                         );
//                     }
//                   }
//                 );
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// }

// useEffect(() => {
//   const formArray = pdfListEnum[formName].files;
//   for (let i = 0; i < formArray.length; i++) {
//     firebase
//       .firestore()
//       .collection("formFields")
//       .doc(formArray[i].pdf)
//       .get()
//       // eslint-disable-next-line no-loop-func
//       .then((doc) => {
//         const tempData = doc.data();
//         for (let j = 0; j < personType.length; j++) {
//           if (tempData[personType[j]].length !== 0) {
//             for (let k = 0; k < tempData[personType[j]].length; k++) {
//               tempData[personType[j]][k].key =
//                 tempData[personType[j]][k].value;
//               return setRefObj({
//                 ...tempData,
//                 [personType[j]]: {
//                   [tempData[personType[j]][k].key]:
//                     tempData[personType[j]][k].value,
//                 },
//               });
//             }
//           }
//         }
//         // tempData[i] = doc.data();
//         // setTempObj(tempData);
//       })
//       .catch((err) => {
//         global.alert(err);
//       });
//   }
// }, []);

// const { PDFDocument } = require("pdf-lib");
// const crypto = require("crypto");
// const formArray = await pdfListEnum[formName].files;
// const formPdfBytes = await global
//   .fetch("https://storage.googleapis.com/auto-fill/forms/i-589.pdf")
//   .then((res) => res.arrayBuffer());

// const pdfDoc = await PDFDocument.load(formPdfBytes);

// const form = pdfDoc.getForm();

// const fields = form.getFields();
// fields.forEach((field) => {
//   const type = field.constructor.name;
//   const name = field.getName();
//   console.log(`${name}`);
// });

// eslint-disable-next-line no-loop-func
// await storageRef.getDownloadURL().then((url) => {
//   obj.forms.push({
//     formName: formArray[i],
//     url: url,
//   });
// });

/* <Grid.Column></Grid.Column>
            <Grid.Column>
              {pdfListEnum[formName].fields[type] !== null &&
                pdfListEnum[formName].fields[type].bio !== null && (
                  <>
                    <Header>Biographic Information</Header>
                    {pdfListEnum[formName].fields[type].bio.map((item) =>
                      item.key !== "genderCheckbox" ? (
                        <>
                          <Form.Input
                            onChange={(e) =>
                              setFormObj({
                                ...formObj,
                                [type]: {
                                  ...formObj[type],
                                  [item.key]: e && e.target && e.target.value
                                },
                              })
                            }
                            key={item.key}
                            fluid
                            placeholder={item.key}
                          />
                          <Form.Field>
                            Value:{" "}
                            {formObj[type] !== null &&
                              formObj[type][item.key] &&
                              formObj[type][item.key]}
                          </Form.Field>
                        </>
                      ) : (
                        <>
                          <Form.Select
                            onChange={(e, { value }) =>
                              setFormObj({
                                ...formObj,
                                [type]: {
                                  ...formObj[type],
                                  bio: {
                                    ...formObj[type].bio,
                                    [item.key]: value,
                                  },
                                },
                              })
                            }
                            clearable
                            key={item.key}
                            fluid
                            options={item.option}
                            placeholder="Gender"
                          />
                          <Form.Field>
                            Value:{" "}
                            {formObj[type].bio[item.key] &&
                              formObj[type].bio[item.key]}
                          </Form.Field>
                        </>
                      )
                    )}
                  </>
                )}
            </Grid.Column>
            <Grid.Column>
              {pdfListEnum[formName].fields[type] !== null &&
                pdfListEnum[formName].fields[type].mailingAdd !== null && (
                  <>
                    <Header>Mailing Address Information</Header>
                    {pdfListEnum[formName].fields[type].mailingAdd.map((item) =>
                      item.key !== "aptSteFlrCheckBox" ? (
                        <>
                          <Form.Input
                            onChange={(e) =>
                              setFormObj({
                                ...formObj,
                                [type]: {
                                  ...formObj[type],
                                  mailingAdd: {
                                    ...formObj[type].mailingAdd,
                                    [item.key]: e && e.target && e.target.value,
                                  },
                                },
                              })
                            }
                            key={item.key}
                            fluid
                            placeholder={item.key}
                          />
                          <Form.Field>
                            Value:{" "}
                            {formObj[type].mailingAdd[item.key] &&
                              formObj[type].mailingAdd[item.key]}
                          </Form.Field>
                        </>
                      ) : (
                        <>
                          <Form.Select
                            onChange={(e, { value }) =>
                              setFormObj({
                                ...formObj,
                                [type]: {
                                  ...formObj[type],
                                  mailingAdd: {
                                    ...formObj[type].mailingAdd,
                                    [item.key]: value,
                                  },
                                },
                              })
                            }
                            clearable
                            key={item.key}
                            fluid
                            options={item.option}
                            placeholder="Apt. / Ste. / Flr."
                          />
                          <Form.Field>
                            Value:{" "}
                            {formObj[type].mailingAdd[item.key] &&
                              formObj[type].mailingAdd[item.key]}
                          </Form.Field>
                        </>
                      )
                    )}
                  </>
                )}
            </Grid.Column>
            <Grid.Column>
              {pdfListEnum[formName].fields[type] !== null &&
                pdfListEnum[formName].fields[type].physicalAdd !== null && (
                  <>
                    <Header>Physical Address Information</Header>
                    {pdfListEnum[formName].fields[type].physicalAdd.map(
                      (item) =>
                        item.key !== "aptSteFlrCheckBox" ? (
                          <>
                            <Form.Input
                              onChange={(e) =>
                                setFormObj({
                                  ...formObj,
                                  [type]: {
                                    ...formObj[type],
                                    physicalAdd: {
                                      ...formObj[type].physicalAdd,
                                      [item.key]:
                                        e && e.target && e.target.value,
                                    },
                                  },
                                })
                              }
                              key={item.key}
                              fluid
                              placeholder={item.key}
                            />
                            <Form.Field>
                              Value:{" "}
                              {formObj[type].physicalAdd[item.key] &&
                                formObj[type].physicalAdd[item.key]}
                            </Form.Field>
                          </>
                        ) : (
                          <>
                            <Form.Select
                              onChange={(e, { value }) =>
                                setFormObj({
                                  ...formObj,
                                  [type]: {
                                    ...formObj[type],
                                    physicalAdd: {
                                      ...formObj[type].physicalAdd,
                                      [item.key]: value,
                                    },
                                  },
                                })
                              }
                              clearable
                              key={item.key}
                              fluid
                              options={item.option}
                              placeholder="Apt. / Ste. / Flr."
                            />
                            <Form.Field>
                              Value:{" "}
                              {formObj[type].physicalAdd[item.key] &&
                                formObj[type].physicalAdd[item.key]}
                            </Form.Field>
                          </>
                        )
                    )}
                  </>
                )}
            </Grid.Column> */

// form.getTextField("form1[0].#subform[0].PtAILine4_LastName[0]").setText("testoo");

// async function handleTest() {
//   for (let i = 0; i < Object.keys(resultJSON).length; i++) {
//     firebase
//       .firestore()
//       .collection("formMaps")
//       .doc(Object.keys(resultJSON)[i])
//       .set(resultJSON)
//       .then((doc) => {
//         global.alert("Başarılı");
//       })
//       .catch((err) => {
//         global.alert(err);
//       });
//   }
// }

